import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation

export default function PrivacyPage() {
  // Initialize useTranslation for the 'privacy' namespace
  const { t } = useTranslation('privacy');

  // Fetch translated content using t-keys
  const pageTitle = t('privacy.title', 'Privacy Policy');
  const effectiveDate = t('privacy.effective_date', 'Valid from: Unknown Date');

  // Fetch the entire sections object, ensuring it returns an object
  const sections = t('privacy.sections', { returnObjects: true });

  // Define all styles as a JavaScript object, with responsiveness in mind
  const styles = {
    container: {
      maxWidth: '900px', // Max-width for larger screens
      width: '95%',     // Fluid width for responsiveness
      margin: '2rem auto',
      padding: 'clamp(1rem, 5vw, 1.5rem)', // Responsive padding: min 1rem, ideal 5vw, max 1.5rem
      backgroundColor: '#f9f9f9',
      borderRadius: '10px',
      boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
      fontFamily: 'Inter, sans-serif',
      lineHeight: '1.6',
      color: '#333',
      boxSizing: 'border-box', // Ensure padding is included in the width
    },
    pageTitle: {
      fontSize: 'clamp(2rem, 5vw, 2.8rem)', // Responsive font size: min 2rem, ideal 5vw, max 2.8rem
      fontWeight: '700',
      color: '#29B185',
      textAlign: 'center',
      marginBottom: '1rem',
      letterSpacing: '-0.02em',
    },
    effectiveDate: {
      fontSize: 'clamp(0.8rem, 2vw, 0.95rem)', // Responsive font size: min 0.8rem, ideal 2vw, max 0.95rem
      color: '#777',
      textAlign: 'center',
      marginBottom: 'clamp(0.5rem, 1vw, 0.5rem)', // Responsive margin-bottom
      fontWeight: 'bold',
    },
  
    sectionContainer: {
      marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
      padding: 'clamp(1rem, 4vw, 1.5rem)',
      backgroundColor: '#fff',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    },
    sectionTitle: {
      fontSize: 'clamp(1.2rem, 3vw, 1.4rem)',
      fontWeight: '600',
      color: '#2c3e50',
      margin: '0 0 0.8rem 0',
      lineHeight: '1.4',
    },
    sectionBody: {
      fontSize: 'clamp(1.2rem, 3vw, 1.4rem)',
      color: '#555',
      lineHeight: '1.6',
    },
    error: {
      color: 'red',
      textAlign: 'center',
      marginTop: '20px',
      fontSize: '1.2rem',
    }
  };

  // Ensure sections is an object and has keys before mapping
  if (!sections || typeof sections !== 'object' || Object.keys(sections).length === 0) {
    return <div style={styles.error}>No privacy policy sections found or data format is incorrect.</div>;
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.pageTitle}>{pageTitle}</h1>
      <p style={styles.effectiveDate}><strong>{effectiveDate}</strong></p>
      <p style={styles.effectiveDate}>{t('Ver. 1.0')}</p>

      {/* Iterate over the sections object fetched from translations */}
      {Object.entries(sections).map(([key, section]) => (
        <div key={key} style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>{section.title}</h2>
          <p style={styles.sectionBody}>{section.body}</p>
        </div>
      ))}
    </div>
  );
}